import React from 'react';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import { useLocation, useNavigate } from 'react-router-dom';
import SBRefundForm from '../comopnents/SBRefundForm';
import { Stack } from '@mui/material';
import { useCreateRefundHandler } from '../../refunds/dataHandlers/createRefundHandler';

export default function CreateSBRefundPage() {
  useDocumentTitle('Self Billed Refund Form');
  const navigate = useNavigate();
  const location = useLocation();
  const document = location.state.document;

  const onRefundCreated = (payload) => {
    if (payload.status === 'draft') {
      navigate('/self-billed-drafts?tab=self-billed-refunds');
    } else {
      navigate('/self-billed-documents?tab=self-billed-refunds');
    }
  };

  const { onSubmit, error } = useCreateRefundHandler({ onSuccess: onRefundCreated });

  const onSaveAsEInv = async (data) => {
    const payload = {
      ...data,
      status: 'active',
    };

    await onSubmit(payload, data.status);
  };
  const onSaveAsDraft = async (data) => {
    const payload = {
      ...data,
      status: 'draft',
    };
    await onSubmit(payload, data.status);
  };

  const onCancel = () => {
    navigate(location.state?.from || '/self-billed-documents?tab=self-billed-refunds');
  };

  return (
    <Stack direction="column" sx={{ mt: '-2rem' }}>
      <SBRefundForm
        initialData={document || {}}
        onSubmit={onSaveAsEInv}
        onSaveDraft={onSaveAsDraft}
        onCancel={onCancel}
        apiErrors={error}
      />
    </Stack>
  );
}
